
import { Component, Vue, Prop, Watch, Inject } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

@Component
export default class TabButtonhelper extends Vue {
    @Prop({ type: [String, Array], default: '' }) public content!: string | Array<string>;
    @Prop({ type: String, default: '#' }) public href!: string;
    @Prop({ type: Number, default: null }) public posInSet!: number | null;
    @Prop({ type: Number, default:  null }) public setSize!: number | null;
    @Prop({ type: String, default: null }) public controls!: string | null;
    @Prop({ type: String, default: null }) public id!: string | null;
    @Prop({ type: Boolean, default: false }) public active!: boolean;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: [String, Array], default: null }) public linkClass!: string | Array<string> | null;
    @Prop({ type: [String, Array], default: null }) public itemClass!: string | Array<string> | null;
    @Prop({ type: Boolean, default: false }) public noKeyNav!: string | Array<string>;

    private handleClick(event: Event | KeyboardEvent): void {
        function stop() {
            event.preventDefault();
            event.stopPropagation();
        }

        if (event.type !== 'click' && this.noKeyNav) {
            return;
        }

        if (this.disabled) {
            stop();
            return;
        }

        if (event.type !== 'click' && (event as KeyboardEvent).keyCode !== 13 && (event as KeyboardEvent).keyCode !== 32) {
            return;
        }

        stop();
        this.$emit('click', event);
    }
    public render(h: CreateElement): VNode {
        const link = h('a', {
            class: ['nav-link', { active: this.active, disabled: this.disabled }, this.linkClass],
            attrs: {
                'role': 'tab',
                'tabindex': this.noKeyNav ? null : '-1',
                'href': this.href,
                'id': this.id,
                'disabled': this.disabled,
                'aria-selected': this.active ? 'true' : 'false',
                'aria-setsize': this.setSize,
                'aria-posinset': this.posInSet,
                'aria-controls': this.controls,
            },
            on: {
                click: this.handleClick,
                keydown: this.handleClick,
            },
        },
        this.content);

        return h('li', { class: [ 'nav-item', this.itemClass], attrs: { role: 'presentation' }}, [link]);
    }
}
